import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEconomicProjectData(selectedCompanyId?: number) {
    const { data: projects, isPlaceholderData: isPlaceholderDataProjects } = useQuery({
        queryKey: [QueryKey.ECONOMIC_PROJECTS, selectedCompanyId],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.voucher.economic.projects', { company: selectedCompanyId }),
            );
            return data;
        },
        placeholderData: [],
        enabled: !!selectedCompanyId,
    });

    return {
        projects,
        isPlaceholderDataProjects,
    };
}
